import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="12" height="7" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M16 2l-2-2-6 6-6-6-2 2 8 8 8-8z" fill="#6F6F6F" /></svg>;